import { Translations } from '~/context/TranslationContext/models';

export enum ConsumptionType {
  READ = 'read',
  LISTEN = 'listen',
  WATCH = 'watch',
}

export const getConsumptionTypeMap = (
  t?: Translations
): Record<ConsumptionType, string> => ({
  [ConsumptionType.READ]: t?.card?.readContentType ?? 'read',
  [ConsumptionType.LISTEN]: t?.card?.listenContentType ?? 'listen',
  [ConsumptionType.WATCH]: t?.card?.watchContentType ?? 'watch',
});

export const getConsumptionTypeLabel = (
  type: ConsumptionType | null | undefined,
  t?: Translations
): string => {
  if (!type) return '';

  return getConsumptionTypeMap(t)[type];
};
